import { useTrans } from "@/translations";

import { twMerge } from "tailwind-merge";

const ACTIVE_BADGE_URL =
  "https://public.wasteiq.com/icons/carrot-waste-badge-active.png";
const AVAILABLE_BADGE_URL =
  "https://public.wasteiq.com/icons/carrot-waste-badge-available.png";

type Props = {
  id: string;
  icon: string;
  name: string;
  isRecommended?: boolean;
};

export const WasteTypeItem: React.FC<Props> = ({
  id,
  icon,
  name,
  isRecommended = false,
}: Props) => {
  const { t } = useTrans();
  return (
    <div
      key={id}
      className={twMerge(
        "relative w-14",
        name.includes("WEEE") && "hover:animate-spin-y transition-transform",
        "lg:w-16",
      )}
    >
      <div
        className={twMerge("mb-2 h-fit w-fit px-4 py-5", "lg:px-4 lg:py-6")}
        style={{
          backgroundImage: `url(${isRecommended ? AVAILABLE_BADGE_URL : ACTIVE_BADGE_URL})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      >
        <div
          className={twMerge(
            "mb-2 h-6 w-6",
            isRecommended && "opacity-50",
            "lg:h-8 lg:w-8",
          )}
          style={{
            backgroundImage: `url(${icon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        />
      </div>

      {isRecommended && (
        <div
          className={twMerge(
            "bg-lime text-3xs absolute top-12 left-0 h-3 w-14 text-center leading-3",
            "lg:top-16 lg:h-4 lg:w-16 lg:leading-4",
          )}
        >
          {t("genericLabels:recommended")}
        </div>
      )}

      <div
        className={twMerge(
          "font-dm-sans text-2xs text-center leading-3 font-medium break-words text-black",
          isRecommended && "opacity-50",
          "lg:text-xs lg:leading-4",
        )}
      >
        {name}
      </div>
    </div>
  );
};
